import styled from "styled-components";
import { UIWidgetsDiv } from "../common/ui/widgets/division/Division";
export const PopupWrapper = styled(UIWidgetsDiv).attrs({
  name: "popup-wrapper"
})`
  z-index: 110;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  align-items: center;
  overflow: auto;
  > div:first-child {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  > div:nth-child(2) {
    position: relative;
  }
`;
